import Model from "../Model";

export default class FaqSections extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/faq-sections'
    }
}
